import { render, staticRenderFns } from "./SSLCertificates.vue?vue&type=template&id=2ce44e79&"
import script from "./SSLCertificates.vue?vue&type=script&lang=js&"
export * from "./SSLCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports